module.exports = __webpack_public_path__ + "static/media/img15.8d2bae91.JPG";